/* Klaar UI: behavior for the kl-* sections (gallery, colors, name, sticky bar, carousels, videos). */
(function () {
  if (window.KlaarUI) { window.KlaarUI.init(document); return; }
  var motion = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var smooth = motion ? 'smooth' : 'auto';
  var NAMES = { blue: 'Big Blue', bubblegum: 'Bubblegum', oat: 'Oat' };
  /* letters (with accents), spaces, hyphens, apostrophes, & and periods: what the band printer takes */
  var BAD = /[^A-Za-zÀ-ÖØ-öø-ɏ '’&.\-]/;

  function all(root, s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  function once(el, key) { if (!el || el.getAttribute('data-kl-' + key)) return false; el.setAttribute('data-kl-' + key, '1'); return true; }
  function withWidth(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }

  /* ---------- carousels: [data-kl-car] with [data-kl-track], [data-kl-prev], [data-kl-next] ---------- */
  function initCarousel(car) {
    if (!once(car, 'car')) return;
    var track = car.querySelector('[data-kl-track]');
    if (!track) return;
    var scope = car.closest('.kl') || car;
    var prevs = all(scope, '[data-kl-prev]').filter(function (b) { return !b.closest('[data-kl-gal]'); });
    var nexts = all(scope, '[data-kl-next]').filter(function (b) { return !b.closest('[data-kl-gal]'); });
    var center = car.hasAttribute('data-kl-center');
    function step() { var li = track.querySelector(':scope > li'); return li ? li.getBoundingClientRect().width + 20 : track.clientWidth * 0.8; }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prevs.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      nexts.forEach(function (b) { b.disabled = track.scrollLeft >= max; });
      if (center) {
        var mid = track.getBoundingClientRect().left + track.clientWidth / 2, best = null, bestD = 1e9;
        all(track, ':scope > li').forEach(function (li) {
          var r = li.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestD) { bestD = d; best = li; }
        });
        all(track, ':scope > li').forEach(function (li) { li.classList.toggle('is-center', li === best); });
      }
    }
    prevs.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: smooth }); }); });
    nexts.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: smooth }); }); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    if (center && track.children.length > 2 && window.innerWidth >= 750) {
      var mid = track.children[Math.floor(track.children.length / 2)];
      track.scrollLeft = mid.offsetLeft - (track.clientWidth - mid.offsetWidth) / 2;
    }
    update();
  }

  /* ---------- videos: [data-kl-video] ---------- */
  function initVideo(card) {
    if (!once(card, 'vid')) return;
    var video = card.querySelector('video'), btn = card.querySelector('[data-kl-play]');
    if (!video || !btn) return;
    btn.addEventListener('click', function () {
      all(document, '[data-kl-video] video').forEach(function (v) { if (v !== video && !v.paused) { v.pause(); v.closest('[data-kl-video]').classList.remove('is-playing'); } });
      if (video.paused) { video.muted = false; video.play(); card.classList.add('is-playing'); }
      else { video.pause(); card.classList.remove('is-playing'); }
    });
    video.addEventListener('click', function () { video.pause(); card.classList.remove('is-playing'); });
    video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
  }

  /* ---------- accordions: one open at a time inside [data-kl-single] ---------- */
  function initAccordion(group) {
    if (!once(group, 'acc')) return;
    all(group, 'details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        all(group, 'details').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------- product page: gallery, color, name, form, sticky bar, dialogs ---------- */
  function initProduct(root) {
    if (!once(root, 'pdp')) return;
    function one(s) { return root.querySelector(s); }
    var gal = one('[data-kl-gal]'), track = one('[data-kl-gtrack]');
    var slides = all(root, '[data-kl-slide]'), thumbs = all(root, '[data-kl-thumb]');
    var count = one('[data-kl-count]'), prev = gal ? gal.querySelector('[data-kl-prev]') : null, next = gal ? gal.querySelector('[data-kl-next]') : null;
    var form = root.querySelector('#kl-buy-form') || one('[data-kl-form]'), input = one('[data-kl-input]'), chars = one('[data-kl-chars]');
    var hint = one('[data-kl-hint]'), hintText = hint ? hint.textContent : '';
    var variant = one('[data-kl-variant]'), colorName = one('[data-kl-colorname]'), go = one('[data-kl-go]');
    var ret = one('[data-kl-return]'), cartUrl = root.getAttribute('data-cart') || '/cart';
    var sticky = one('[data-kl-sticky]'), stickySel = one('[data-kl-sticky-color]'), stickyGo = one('[data-kl-sticky-go]');
    var bandSlide = slides.indexOf(one('[data-kl-bandslide]'));
    var current = 0, color = root.getAttribute('data-color') || 'blue', busy = false;

    function setSrc(img, c) {
      var base = img.getAttribute('data-src-' + c);
      if (!base) return;
      img.src = withWidth(base, img.getAttribute('data-w') || '1100');
      if (img.hasAttribute('srcset')) img.srcset = [600, 900, 1100, 1400].map(function (x) { return withWidth(base, x) + ' ' + x + 'w'; }).join(', ');
    }

    /* gallery */
    function goTo(i, how) {
      if (!track) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: how || smooth });
    }
    function setCurrent(i, force) {
      if (i === current && !force) return;
      current = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      thumbs.forEach(function (t) {
        var on = +t.getAttribute('data-kl-thumb') === i, list = t.closest('ul');
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && list && list.scrollWidth > list.clientWidth) list.scrollTo({ left: t.parentNode.offsetLeft - list.clientWidth / 2 + t.offsetWidth / 2, behavior: smooth });
      });
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { setCurrent(Math.round(track.scrollLeft / track.clientWidth)); }); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      });
      window.addEventListener('resize', function () { goTo(current, 'auto'); });
    }
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-kl-thumb')); }); });

    /* lightbox */
    var lb = one('[data-kl-lb]');
    if (lb && typeof lb.showModal === 'function' && slides.length) {
      var lbImg = lb.querySelector('[data-kl-lbimg]'), lbName = lb.querySelector('[data-kl-lbname]'), lbCap = lb.querySelector('[data-kl-lbcap]'), at = 0;
      var showLb = function (i) {
        at = (i + slides.length) % slides.length;
        var fig = slides[at], img = fig.querySelector('img'), tag = fig.querySelector('[data-kl-name]');
        lbImg.src = (img.currentSrc || img.src).replace(/width=\d+/, 'width=1400');
        lbImg.alt = img.alt;
        lbCap.textContent = (at + 1) + ' / ' + slides.length + '. ' + img.alt;
        lbName.hidden = !tag;
        if (tag) {
          lbName.className = tag.className;
          lbName.textContent = tag.textContent;
          lbName.style.fontSize = '';
          lbName.parentNode.setAttribute('data-color', color);
        }
      };
      var openLb = function (i) { showLb(i); lb.showModal(); requestAnimationFrame(function () { if (!lbName.hidden) fit(lbName); }); };
      slides.forEach(function (s, i) { s.addEventListener('click', function () { openLb(i); }); });
      var z = one('[data-kl-zoom]');
      if (z) z.addEventListener('click', function () { openLb(current); });
      lb.querySelector('[data-kl-lbprev]').addEventListener('click', function () { showLb(at - 1); if (!lbName.hidden) fit(lbName); });
      lb.querySelector('[data-kl-lbnext]').addEventListener('click', function () { showLb(at + 1); if (!lbName.hidden) fit(lbName); });
      lb.querySelector('[data-kl-lbclose]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') showLb(at + 1);
        if (e.key === 'ArrowLeft') showLb(at - 1);
      });
    }

    /* other dialogs (what's in the box) */
    all(root, '[data-kl-open]').forEach(function (b) {
      var d = root.querySelector('[data-kl-dialog="' + b.getAttribute('data-kl-open') + '"]');
      if (!d || typeof d.showModal !== 'function') return;
      b.addEventListener('click', function (e) { e.preventDefault(); d.showModal(); });
      all(d, '[data-kl-close]').forEach(function (c) { c.addEventListener('click', function () { d.close(); }); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    });

    /* color */
    function setColor(radio, quiet) {
      color = radio.getAttribute('data-kl-color');
      root.setAttribute('data-color', color);
      if (colorName) colorName.textContent = NAMES[color] || radio.value;
      all(root, '[data-src-' + color + ']').forEach(function (img) { setSrc(img, color); });
      var id = radio.getAttribute('data-kl-variant-id');
      if (variant && id) {
        variant.value = id;
        variant.dispatchEvent(new Event('change', { bubbles: true }));
        if (!quiet && window.history && history.replaceState) {
          try { var url = new URL(window.location.href); url.searchParams.set('variant', id); history.replaceState(history.state, '', url.toString()); } catch (err) {}
        }
      }
      if (stickySel && stickySel.value !== color) stickySel.value = color;
      emit('klaar:color', { color: color, label: NAMES[color] || radio.value });
    }
    all(root, '[data-kl-color]').forEach(function (radio) { radio.addEventListener('change', function () { setColor(radio); }); });
    if (stickySel) stickySel.addEventListener('change', function () {
      var r = root.querySelector('[data-kl-color="' + stickySel.value + '"]');
      if (r && !r.disabled) { r.checked = true; setColor(r); }
    });

    /* name: optional, shown live on the photos and shrunk to fit the band */
    function clean() { return input ? input.value.replace(/\s+/g, ' ').trim() : ''; }
    function say(text, alert) { if (!hint) return; hint.textContent = text; hint.classList.toggle('is-alert', !!alert); }
    function fit(el) {
      el.style.fontSize = '';
      var r = document.createRange();
      r.selectNodeContents(el);
      var w = r.getBoundingClientRect().width, room = el.clientWidth * 0.9;
      if (w > room && room > 0) el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * room / w) + 'px';
    }
    function fitAll() { all(root, '[data-kl-name]').forEach(fit); }
    function setName(e) {
      if (!input) return;
      if (!(e && e.isComposing) && BAD.test(input.value)) {
        var at = input.selectionStart, before = input.value.length;
        input.value = input.value.split('').filter(function (ch) { return !BAD.test(ch); }).join('');
        if (at != null && document.activeElement === input) { at -= before - input.value.length; input.setSelectionRange(at, at); }
        say('Letters, spaces, hyphens, apostrophes, & and periods only.', true);
      } else if (e && hint && hint.classList.contains('is-alert')) {
        say(hintText);
      }
      var v = clean();
      all(root, '[data-kl-name]').forEach(function (el) {
        el.textContent = v || input.placeholder;
        el.classList.toggle('is-example', !v);
        fit(el);
      });
      if (chars) chars.textContent = input.value.length + ' of ' + (input.maxLength > 0 ? input.maxLength : 12);
      emit('klaar:name', { name: v });
    }
    if (input) {
      input.addEventListener('input', setName);
      input.addEventListener('focus', function () {
        if (bandSlide > -1 && window.matchMedia('(min-width: 1000px)').matches && current !== 1 && current !== bandSlide) goTo(1);
      });
    }
    if ('ResizeObserver' in window && track) new ResizeObserver(fitAll).observe(track); else window.addEventListener('resize', fitAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

    /* pre-order: one submit at a time; with other things in the cart, go to the cart first */
    function setBusy(on) { busy = on; if (go) { go.setAttribute('aria-disabled', on ? 'true' : 'false'); } }
    if (form) {
      form.addEventListener('submit', function (e) {
        if (busy) { e.preventDefault(); return; }
        if (input) input.value = clean();
        setTimeout(function () { if (!e.defaultPrevented) { setBusy(true); setTimeout(function () { setBusy(false); }, 8000); } }, 0);
      });
    }
    function checkCart() {
      if (!ret || !window.fetch) return;
      fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (c) { ret.value = c.item_count > 0 ? cartUrl : '/checkout'; }).catch(function () {});
    }
    window.addEventListener('pageshow', function () { setBusy(false); checkCart(); });

    /* sticky bar: shows once the main button has scrolled away; hides at [data-kl-end] */
    if (sticky && go) {
      var stickyOn = null, sraf = 0;
      var check = function () {
        sraf = 0;
        var g = go.getBoundingClientRect(), end = document.querySelector('[data-kl-end]'), vh = window.innerHeight;
        var past = g.bottom < 0;
        var atEnd = false;
        if (end) { var e = end.getBoundingClientRect(); atEnd = e.top < vh && e.bottom > 0; }
        var on = past && !atEnd;
        if (on === stickyOn) return;
        stickyOn = on;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        all(sticky, 'button,select').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      };
      var queue = function () { if (!sraf) sraf = requestAnimationFrame(check); };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      check();
    }
    if (stickyGo && form) stickyGo.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(go); else go.click();
    });

    /* "watch a routine" links play the demo section if it is on the page */
    all(document, '[data-kl-playdemo]').forEach(function (el) {
      if (!once(el, 'demo')) return;
      el.addEventListener('click', function (e) {
        var demo = document.getElementById('kl-demo');
        if (!demo) return;
        e.preventDefault();
        demo.scrollIntoView({ behavior: smooth, block: 'start' });
        emit('klaar:demo-play');
      });
    });

    /* start */
    var start = root.querySelector('[data-kl-color]:checked');
    if (start) setColor(start, true);
    setName();
    setCurrent(0, true);
  }

  /* any button that sends the pre-order form on the product page ([data-kl-submit]) */
  function initSubmitters(scope) {
    all(scope, '[data-kl-submit]').forEach(function (b) {
      if (!once(b, 'sub')) return;
      b.addEventListener('click', function (e) {
        var form = document.getElementById('kl-buy-form'), btn = form && form.querySelector('[data-kl-go]');
        if (!btn) return;
        e.preventDefault();
        if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    all(scope, '[data-kl-pdp]').forEach(initProduct);
    all(scope, '[data-kl-car]').forEach(initCarousel);
    all(scope, '[data-kl-video]').forEach(initVideo);
    all(scope, '[data-kl-single]').forEach(initAccordion);
    initSubmitters(scope);
  }

  window.KlaarUI = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
